
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog-post/2017/11/data-engineering-on-gcp-specialization-coursera-review",
      function () {
        return require("private-next-pages/blog-post/2017/11/data-engineering-on-gcp-specialization-coursera-review.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog-post/2017/11/data-engineering-on-gcp-specialization-coursera-review"])
      });
    }
  